import React, { Component } from 'react';
export default class FormField extends Component {
  constructor () {
    super();
  }

  render () {
    return (
      <li className={this.props.className}>
        {this.props.children}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/form/FormField.js